var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentLanguage.toUpperCase() === 'EN')?_c('PrivacyEn'):(_vm.currentLanguage.toUpperCase() === 'IT')?_c('PrivacyIt'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }